import { render, staticRenderFns } from "./CustomerDetail.vue?vue&type=template&id=51d5209f&scoped=true"
import script from "./CustomerDetail.vue?vue&type=script&lang=js"
export * from "./CustomerDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetail.vue?vue&type=style&index=0&id=51d5209f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5209f",
  null
  
)

export default component.exports